import '../plugins/custom-select.min.js';

const filterBrand = document.querySelector('#filter-brand');
const filterBody = document.querySelector('#filter-body');
const filterPriceMin = document.querySelector('#filter-price-min');
const filterPriceMax = document.querySelector('#filter-price-max');
const filterSort = document.querySelector('#filter-sort');
const loadMore = document.querySelector('#load-more');

const fieldName1 = document.querySelector('#field-name-1').value;
const fieldName2 = document.querySelector('#field-name-2').value;
const fieldAfter1 = document.querySelector('#field-after-1').value;
const fieldAfter2 = document.querySelector('#field-after-2').value;
const fieldToShow = document.querySelector('#field-to-show').value;

let cat = document.querySelector('#cat').value;
let brand = document.querySelector('#brand').value;
let body = document.querySelector('#body').value;

const carsPerPage = 16;

let selectedType = [];
let selectedBrand = [];
let selectedMinPrice = 0;
let selectedMaxPrice = 0;
let selectedSort = document.querySelector('#filter-sort').value;
let page = 1;

customSelect(filterPriceMin);
customSelect(filterPriceMax);
customSelect(filterSort);

if(filterBrand) {
    filterBrand.addEventListener('change', filterModels);
}
if(filterBody) {
    filterBody.addEventListener('change', filterModels);
}
filterPriceMin.addEventListener('change', filterModels);
filterPriceMax.addEventListener('change', filterModels);
filterSort.addEventListener('change', filterModels);

loadMore.addEventListener('click', e => {
    filterModels(false, true);
    page++;
});

const loader = document.querySelector('#loading');
const target = document.querySelector('#models-target');

filterModels();

function filterModels(e, appendCars = false) {
    if(e) {
        const values = [...e.srcElement.options].filter(opt => opt.selected).map(option => option.value);

        if(e.srcElement.id === 'filter-body') {
            selectedType = values;
        } else if(e.srcElement.id === 'filter-brand') {
            selectedBrand = values;
        } else if(e.srcElement.id === 'filter-price-min') {
            selectedMinPrice = values;
        } else if(e.srcElement.id === 'filter-price-max') {
            selectedMaxPrice = values;
        } else if(e.srcElement.id === 'filter-sort') {
            selectedSort = values;
        }
    }

    loadMore.style.display = 'none';
    loader.style.display = 'inline-block';
    if(!appendCars) {
        target.innerHTML = '';
        page = 1;
    }

    const form = new FormData();
    form.append('action', 'nobox_filter_models');
    form.append('brand', selectedBrand);
    form.append('body', selectedType);
    form.append('min_price', selectedMinPrice);
    form.append('max_price', selectedMaxPrice);
    form.append('sort', selectedSort);
    form.append('cars_per_page', carsPerPage);
    form.append('page', page);
    form.append('fieldName1', fieldName1);
    form.append('fieldName2', fieldName2);
    form.append('fieldAfter1', fieldAfter1);
    form.append('fieldAfter2', fieldAfter2);
    form.append('fieldToShow', fieldToShow);
    form.append('showEmpty', filterSort.dataset.show)

    form.append('adminCat', cat);
    form.append('adminBrand', brand);
    form.append('adminBody', body);

    if(cat && typeof cat === 'string') {
        cat = cat.split(',');
    }
    if(brand && typeof brand === 'string') {
        brand = brand.split(',');
    }
    if(body && typeof body === 'string') {
        body = body.split(',');
    }

    const params = new URLSearchParams(form);

    fetch(horizon.ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache',
        },
        body: params
    })
    .then(response => response.json())
    .then(data => {
        target.innerHTML += data.html;

        loader.style.display = 'none';

        let string = '';
        Object.entries(data.brands).forEach(item => {
            if(item[0] !== '') {
                let selected = '';
                if((selectedBrand.length > 0 && selectedBrand.find(brand => brand === item[0])) || (brand.length > 0 && brand.find(brand => brand === item[0]))) {
                    selected = 'selected';
                }
                string += '<option class="' + (item[1] === 0 ? 'empty' : '') + '" value="' + item[0] + '" ' + selected + '>' + item[0] + ' (' + item[1] +')</option>'
            }
        });
        if(filterBrand) {
            filterBrand.innerHTML = string;
            if(filterBrand && typeof filterBrand.loadOptions !== "undefined") {
                filterBrand.loadOptions();
            }
        }

        string = '';
        Object.entries(data.bodies).forEach(item => {
            if(item[0] !== '') {
                let selected = '';
                if((selectedType.length > 0 && selectedType.find(type => type === item[0])) || body.length > 0 && body.find(type => type === item[0])) {
                    selected = 'selected';
                }
                string += '<option class="' + (item[1] === 0 ? 'empty' : '') + '" value="' + item[0] + '" ' + selected + '>' + item[0] + ' (' + item[1] +')</option>'
            }
        });

        if(filterBody) {
            filterBody.innerHTML = string;
            if(filterBody && typeof filterBody.loadOptions !== "undefined") {
                filterBody.loadOptions();
            }
        }
        page++;
        if(data.has_more === true) {
            loadMore.style.display = 'inline-block';
        } else {
            loadMore.style.display = 'none';
        }
    })
}
